import { createStore } from 'vuex'
import request from '@/utils/request';
import { solutionList } from '@/api/solution';

export default createStore({
  state: {
    solutionList: [], // 解决方案列表数据
    solutionLoading: false, // 加载状态
    solutionError: null, // 错误信息
    currentIndex: 0, // 默认导航到第一个页面
  },
  getters: {
    getCurrentIndex (state) {
      return state.currentIndex
    },
    getSolutionList: (state) => state.solutionList,
    isSolutionLoading: (state) => state.solutionLoading,
    getSolutionError: (state) => state.solutionError,
  },
  mutations: {
    setCurrentIndex (state, index) {
      state.currentIndex = index
    },
    // 设置解决方案列表
    SET_SOLUTION_LIST(state, data) {
      state.solutionList = data;
    },
    // 设置错误信息
    SET_SOLUTION_ERROR(state, error) {
      state.solutionError = error;
    },
    // 设置加载状态
    SET_SOLUTION_LOADING(state, loading) {
      state.solutionLoading = loading;
    },
  },
  actions: {
    setCurrentIndex ({ commit }, index) {
      commit('setCurrentIndex', index)
    },
    // 获取解决方案列表
    async fetchSolutionList({ commit }, params = {}) {
      commit('SET_SOLUTION_LOADING', true);
      commit('SET_SOLUTION_ERROR', null);
      
      try {
        // 使用导入的 solutionList 函数
        const response = await solutionList(params);
        
        // 注意：根据request.js中的配置，成功状态码是1
        if (response.code === 1) {
          commit('SET_SOLUTION_LIST', response.data || []);
        } else {
          commit('SET_SOLUTION_ERROR', response.message || '获取解决方案列表失败');
        }
      } catch (error) {
        commit('SET_SOLUTION_ERROR', error.message || '网络错误');
        console.error('获取解决方案列表异常：', error);
      } finally {
        commit('SET_SOLUTION_LOADING', false);
      }
    },
  },
  modules: {
  }
})